import React, { Component } from 'react';

import { connect } from 'react-redux';

import * as NotificationsHistoric from 'notifications_historic/components';
import NotificationHistoricFormHandlers from 'notifications_historic/containers/NotificationHistoricFormHandlers';

import { getVisibleCustomFieldsEmployees } from 'custom_fields_employees/selectors'; //Groups
import { getVisibleGroups } from 'groups/selectors'; //Groups

import {
  getIsSaving,
  getIsFetching,
  getEditing,
  getIsFetchingConfig,
  getVisibleNotificationsHistoric,
} from 'notifications_historic/selectors';
import { getVisibleDepreciations } from 'selectors/lists';
import { getCompany, getSubcompany } from 'auth/selectors';

class NotificationsHistoricFormContainer extends Component {
  render = () => (
    <NotificationHistoricFormHandlers
      render={({
        isSubmitted,
        isSaving,
        handleValueChange,
        handleValidation,
        handleSubmit,
        handleRemoveCustomField,
        handleGroupChange, //Groups
        handleCustomFieldChange, //Groups
        handleAddCustomField,
        notifications_elementsBySections,
        allSections,
        handleAddToNotify,
        handleRemoveToNotify,
        handleCheckSection,
        handleCheckPermission,
        handleClickPermissionRow,
      }) => (
        <NotificationsHistoric.FormView
          subcompany={this.props.subcompany}
          isSubmitted={isSubmitted}
          isSaving={isSaving}
          isFetching={this.props.isFetching}
          handleValueChange={handleValueChange}
          handleValidation={handleValidation}
          notifications_elementsBySections={notifications_elementsBySections}
          allSections={allSections}
          handleAddToNotify={handleAddToNotify}
          handleRemoveToNotify={handleRemoveToNotify}
          handleCheckSection={handleCheckSection}
          handleCheckPermission={handleCheckPermission}
          handleClickPermissionRow={handleClickPermissionRow}
          handleSubmit={handleSubmit}
          handleGroupChange={handleGroupChange} //Groups
          handleCustomFieldChange={handleCustomFieldChange} //Groups
          groups={this.props.groups} //Groups
          handleRemoveCustomField={handleRemoveCustomField}
          handleAddCustomField={handleAddCustomField}
          depreciations={this.props.depreciations}
          company={this.props.company}
          notification_historic={this.props.notification_historic}
          notificationHistoric={this.props.notificationHistoric}
        />
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  isSaving: getIsSaving(state),
  isFetching: getIsFetching(state),
  isFetchingConfig: getIsFetchingConfig(state),
  notificationHistoric: getEditing(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
  customfields: getVisibleCustomFieldsEmployees(state), //Groups
  groups: getVisibleGroups(state), //Groups
  notification_historic: getVisibleNotificationsHistoric(state),
  depreciations: getVisibleDepreciations(state),
});

export default connect(mapStateToProps, null)(NotificationsHistoricFormContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/containers/NotificationsHistoricFormContainer.js